
import React from 'react';
import { Lightbulb, Sparkles, PenTool, Zap } from 'lucide-react';

interface InsightIconProps {
  insightKey: string;
}

export const InsightIcon: React.FC<InsightIconProps> = ({ insightKey }) => {
  switch (insightKey) {
    case 'expert_insight':
      return <Sparkles className="h-5 w-5 mr-2" />;
    case 'unexpected_analogy':
      return <Zap className="h-5 w-5 mr-2" />;
    case 'challenged_assumption':
      return <PenTool className="h-5 w-5 mr-2" />;
    case 'insider_tip':
      return <Lightbulb className="h-5 w-5 mr-2" />;
    default:
      return <Sparkles className="h-5 w-5 mr-2" />;
  }
};
